import { gql } from '@apollo/client';

export const GET_TMS_LOADING_DETAIL_SUMMARY = gql`
    query GetTmsLoadingDetailSummaryForPortal($taskId: Long!, $taskWayPointId: Long!) {
        getTmsLoadingDetailSummaryForPortal(taskId: $taskId, taskWayPointId: $taskWayPointId) {
            destinationGroups {
                destinationSortingCode
                containers {
                    containerType
                    containerCount
                    destinationWarehouseId
                    destinationSortingCode
                }
            }
        }
    }
`;

export interface TmsLoadingDetailContainerSummary {
    containerType?: number | null;
    containerCount: number;
    destinationWarehouseId?: number | null;
    destinationSortingCode?: string | null;
}

export interface TmsLoadingDetailDestinationGroupSummary {
    destinationSortingCode?: string | null;
    containers: TmsLoadingDetailContainerSummary[];
}

export interface GetTmsLoadingDetailSummaryResponse {
    getTmsLoadingDetailSummaryForPortal: {
        destinationGroups: TmsLoadingDetailDestinationGroupSummary[];
    };
}

export interface GetTmsLoadingDetailSummaryVariables {
    taskId: number;
    taskWayPointId: number;
}
